import { useWorkOrderHasRemovedItems } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.hooks';
import { useWorkorderDetailContext } from '../../WorkorderDetailProvider';
import { Button } from 'antd';
import { useDisclosure } from '@/hooks';
import RestoreItemsModal from '../RestoreItemsModal';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
import { WorkOrderComplementStatus } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { useEffect } from 'react';

const WorkOrderItemRestoreItems: React.FC = () => {
  const {
    complement: { data: complement },
  } = useWorkorderDetailContext();

  const isClosed = complement?.status === WorkOrderComplementStatus.Closed;

  const [modalItemsRemovedVisible, modalItemsRemovedAction] =
    useDisclosure(false);

  const hasRemovedItens = useWorkOrderHasRemovedItems(complement?.id);

  useEffect(() => {
    if (!hasRemovedItens?.data) {
      modalItemsRemovedAction.close();
    }
  }, [hasRemovedItens?.data]);

  if (!hasRemovedItens?.data) return null;

  return (
    <>
      <Button
        disabled={
          !hasPermissions([
            Authorities.MOVIMENTATION_WORKORDER_RESTORE_ITEMS,
          ]) || isClosed
        }
        block
        onClick={modalItemsRemovedAction.open}
      >
        Restaurar itens
      </Button>

      <RestoreItemsModal
        open={modalItemsRemovedVisible}
        onCancel={modalItemsRemovedAction.close}
      />
    </>
  );
};

export default WorkOrderItemRestoreItems;
